/**
 * Parses a tel link
 *
 * A tel link starts with 'tel:' followed by a phone number. The number can be
 * prefixed with a plus '+'. Allowed characters are digits, hash '#', star '*'
 * and visual separators dash '-', dot '.' and parenthesis '()'.
 *
 * A tel link may contain parameters after the number. They are ignored here.
 */
const telRegex = /^tel:(?<number>\+?[\d#*\-.()]+)/u

const visualSeparatorRegex = /[-.()]/g

const parseTelLink = (link) => {
  return (link.match(telRegex)?.groups?.number || '')
    .replace(visualSeparatorRegex, '')
}

export { parseTelLink }
